module.exports = "/_next/static/images/StayingAheadOfTheCurve-sm@2x-5da72b2ebf14ff5e6e27fa3cca46027b.webp";